import React, { useState, useEffect } from 'react'
import { Grid, GridColumn, GridNoRecords } from '@progress/kendo-react-grid'
import cellActions from './cellActions.pure'
import { useTranslation } from 'react-i18next'
import { useMediaQuery } from '@material-ui/core'
import { profileIconDefault } from '../../../assets/logos/icons'
import cellDetailAditionalServices from '../signature-request-panel/cellDetailAditionalService'
import cellDetailSignatureRequest from '../signature-request-panel/cellDetailSignatureRequest'
import { TooltipHLPure, CheckBoxHLPure } from '..'
import './gridHL.css'
import { SimpleLoading } from '..'

const GridHLPure = (props) => {
  const { t } = useTranslation()

  const {
    skip, //Number pagination {0}
    take, //Number pagination {6}
    dataGrid, //Array information to grid
    titleRow1, //Header first column
    title2Status, //Header second column
    titleRow3, //Header third column
    titleRow4, // Header fourth column
    fieldRow1, //Body information row to first column
    field2Status, //Body information row to second column
    fieldRow3, //Body information row to third column
    fieldTitle, //Title first column, name
    fieldSubtitle, //Subtitle first column
    textSubtitle, //Text more subtitle first column
    fieldImg, //Choose image th
    filter, //True to filter grid
    onFilterChange, //Filter function to grid
    onSelectedItem, //Select information item grid
    setShowDetails, //True or false, show detail
    setNameComponentUser, //Name item actions, section
    column2Status, //True to active second column
    columnNoPassword, //True to show no password column
    fieldNoPassword, //Field for no password column
    titleNoPassword, //Title for no password column
    tooltipNoPassword, //Tooltip for no password column
    onNoPasswordChange, //Function to handle no password checkbox change
    columnThree, //You need the second column boolean, true active third column
    iconColumnThree, //The column have icon boolean
    iconActiveThree, //Icon active
    textColumnThree, //If the column has text
    columnFour, //True or false to active four column
    iconOptionOne, //First img option
    iconOptionThree, //Second img option
    iconOneActiveSelected, //Active one button item, True or false if you use value from array
    iconOneActive, //Active section/item actions, fisrt item action
    iconTwoActive, //Active section/item actions, second item action
    iconTwoActiveSelected, //Active one button item, True or false if you use value from array
    iconThirdActive, //Active section/item actions, third item action
    iconFourthActive, //Active section/item actions, four item action
    iconFifthActive, //Active section/item actions, fifth item action
    iconTrashActive, // Active trash icon
    labelOneActions, //Label fisrt item action
    labelTwoActions, //Label second item action
    labelTwoActions2, // Label second option text to action column
    labelThirdActions, //Label third item action
    labelFourthActions, //Label fourth item action
    labelFifthActions, //Label fifth item action
    labelTrashActions, //Label trash icon
    tooltipTrashIcon = t('ModalDelete.title'), // Trash icon tooltip text
    widthHeaderCol1,
    widthHeaderCol2,
    widthHeaderCol3,
    widthHeaderCol4,
    widthHeaderGeneral,
    styleCol1, //Class to td (col1) from table, especifies width
    styleCol2, //Class to td (col2) from table, especifies width
    styleCol3, //Class to td (col3) from table, especifies width
    styleCol4, //Class to td (col4) from table, especifies width
    iconAvatar, //True to show avatar image or false to not show
    iconStatus, //True or false, icon to column three
    activeDialog1, //True to function active dialog and false to change page
    btnOpenDialog1, //Function to open dialog in cellAction
    showDialogYesNo, //Value true or false, to dialog
    extraColumnInbox,
    titleExtraColumn,
    fieldRow4,
    otherExtraColumnInbox,
    titleOtherExtraColumn,
    fieldRow5,
    featuresColumnInbox,
    otherFeaturesColumn,
    titleFeaturesColumn,
    fieldRow6,
    inboxTypeCell,
    styleCol5,
    styleCol6,
    styleCol7,
    columnThreeInbox,
    widthForFirstColumn,
    showFeatures,
    showLimitDate,
    showCreatedDate,
    showStatus,
    columnFourForInbox,
    loading,
    stylesForLastColumn,
    changeSort,
    stateSortStart,
    stateSortLimit,
    pageable = true,
    minHeight,
    styleGrid,
    fieldRow1Path,
    fieldRowSubtitlePath,
    fieldRow1PathDefault,
    activeDialog2, //Function to open dialog on second btn in cellAction
    btnOpenDialog2, //Function to open dialog on second btn in cellAction
    showDialogYesNo2, //Value true or false, to dialog on second btn
    activeDialogTrash,
    btnOpenDialogTrash,
    showDialogYesNoTrash,
    labelsColumnsNoPadding, //labels no have padding in columns
    styleHeader1, //style for header in column 1
    styleHeader4, //style for header in column
    styleHeader3,
    widthHeader,
    mobileFunction,
    iconSubtitle,
    iconField
  } = props

  const initialDataState = {
    skip,
    take,
  }
  const [page, setPage] = useState(initialDataState)
  const mobileResolution = useMediaQuery('(max-width:720px)')
  const [selectedItem, setSelectedItem] = useState({})

  const SignRequestCellHeader = (props) => {
    const cellHeaderStyles = {
      color: '#3B444D',
      fontSize: '14px',
      display: 'flex',
      justifyContent: mobileResolution ? 'end' : 'start',
      fontFamily: 'Quicksand',
    }
    return <span style={(styleHeader4) ? styleHeader4 : cellHeaderStyles}>{props.title}</span>
  }

  const SignRequestCellHeaderFourthCell = (props) => {
    const cellHeaderStyles = {
      color: '#3B444D',
      fontSize: '14px',
      display: 'flex',
      fontFamily: 'Quicksand',
    }
    return <span style={stylesForLastColumn ? { ...cellHeaderStyles, ...stylesForLastColumn } : cellHeaderStyles} className={widthHeaderCol4}>{props.title}</span>
  }

  const SignRequestCellSolicilud = (props) => {
    return (
      <td className={styleCol1}>
        <div className='gridHLPure-solicitud'>
          <i
            className='k-icon k-i-more-vertical'
          ></i>
          <span className='gridHLPure-userName'>
            {props.dataItem[fieldRow1] || '----'}
            {iconSubtitle &&
              <div style={{ fontWeight: 'normal' }}>
                <div className='gridHLPure-column1-container'>
                  {(props.dataItem[iconField]) &&
                    <img className='gridHLPure-column1-img' src={props.dataItem[iconField]} />
                  }
                  <span className='gridHLPure-column1-subtitle'>
                    {fieldRowSubtitlePath
                      ? props.dataItem[fieldRowSubtitlePath][fieldSubtitle]
                      : fieldSubtitle && !textSubtitle
                        ? props.dataItem[fieldSubtitle]
                        : ''}
                  </span>
                </div>
              </div>
            }
          </span>
        </div>
      </td>
    )
  }

  const SignRequestCellHeaderInboxLimit = (props) => {
    const stylesSpanCellHeader = {
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      color: '#3B444D',
      fontSize: '14px',
      fontFamily: 'Quicksand, sans-serif',
    }

    const stylesIconCellHeader = {
      marginLeft: '4px',
    }

    let iconFilter = 'k-i-arrows-swap'

    if (stateSortLimit === 1) {
      iconFilter = 'k-i-sort-asc-sm'
    } else if (stateSortLimit === 2) {
      iconFilter = 'k-i-sort-desc-sm'
    } else {
      iconFilter = 'k-i-arrows-swap'
    }

    return (
      <span
        style={stylesSpanCellHeader}
        onClick={() => changeSort(undefined, stateSortLimit)}
      >
        {props.title}
        <i style={stylesIconCellHeader} className={`k-icon ${iconFilter}`}></i>
      </span>
    )
  }

  const SignRequestCellHeaderInboxStart = (props) => {
    const stylesSpanCellHeader = {
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      color: '#3B444D',
      fontSize: '14px',
      fontFamily: 'Quicksand, sans-serif',
    }

    const stylesIconCellHeader = {
      marginLeft: '4px',
    }

    let iconFilter = 'k-i-arrows-swap'

    if (stateSortStart === 1) {
      iconFilter = 'k-i-sort-asc-sm'
    } else if (stateSortStart === 2) {
      iconFilter = 'k-i-sort-desc-sm'
    } else {
      iconFilter = 'k-i-arrows-swap'
    }

    return (
      <span
        style={stylesSpanCellHeader}
        onClick={() => changeSort(stateSortStart)}
      >
        {props.title}
        <i style={stylesIconCellHeader} className={`k-icon ${iconFilter}`}></i>
      </span>
    )
  }


  const solitudeInboxHeader1 = (props) => {
    const gridColumnGeneralStyle = {
      fontSize: '14px',
      color: '#3B444D',
      display: 'flex',
      alignItems: 'center',
    }
    return <span style={(styleHeader1) ? { ...gridColumnGeneralStyle, ...styleHeader1 } : gridColumnGeneralStyle}>{props.title}</span>
  }


  const solitudeInboxHeader = (props) => {
    const gridColumnGeneralStyle = {
      fontSize: '14px',
      color: '#3B444D',
      display: 'flex',
      alignItems: 'center',
    }
    return <span style={(styleHeader3) ? { ...gridColumnGeneralStyle, ...styleHeader3 } : gridColumnGeneralStyle}>{props.title}</span>
  }

  const noPasswordHeaderCell = (props) => {
    const gridColumnGeneralStyle = {
      fontSize: '14px',
      color: '#3B444D',
      display: 'flex',
      alignItems: 'center',
      gap: '5px'
    }
    return (
      <div style={gridColumnGeneralStyle}>
        <span>
          {props.title}
        </span>
        {tooltipNoPassword && (
          <TooltipHLPure
            positionTooltip={'right'}
            titleTooltip={props.title}
            descriptionTooltip={tooltipNoPassword}
            informationIcon
            styleTooltipIcon="tooltipHLPure-icon-container"
          />
        )}
      </div>
    )
  }

  const avatarCell = (props) => {
    return (
      <td className={styleCol1}>
        <div className={(labelsColumnsNoPadding) ? 'gridHLPure-containerAvatar-no-margin' : 'gridHLPure-containerAvatar'}>
          {iconAvatar === true ? (
            <div className='gridHLPure-imageAvatar'>
              <img
                alt='profile-img'
                src={props.dataItem[fieldImg] || profileIconDefault}
                className='gridHLPure-avatar'
              />
            </div>
          ) : (
            ' '
          )}
          <div className={'gridHLPure-containerLabel'}>
            <span className='gridHLPure-userName'>
              {fieldRow1PathDefault &&
                props.dataItem[fieldRow1Path][fieldRow1].length === 0
                ? props.dataItem[fieldRow1Path][fieldRow1PathDefault] || '----'
                : fieldRow1Path
                  ? props.dataItem[fieldRow1Path][fieldRow1] || '----'
                  : props.dataItem[fieldRow1] || '----'}
            </span>
            {
              (textSubtitle || fieldSubtitle) &&
              <div className='gridHLPure-detailsContainer'>
                <span className='gridHLPure-fieldSubtitle'>
                  {textSubtitle && fieldSubtitle
                    ? textSubtitle + ' ' + props.dataItem[fieldSubtitle]
                    : textSubtitle}
                  {fieldRowSubtitlePath
                    ? props.dataItem[fieldRowSubtitlePath][fieldSubtitle]
                    : fieldSubtitle && !textSubtitle
                      ? props.dataItem[fieldSubtitle]
                      : ''}
                </span>
              </div>
            }
          </div>
        </div>
      </td>
    )
  }

  const gridSignatureRequestPanelStyle = {
    minHeight: minHeight,
    fontFamily: 'Quicksand, sans-serif',
    ...styleGrid,
  }

  const columnTwoCell = (props) => {
    return (
      <td className={styleCol2}>
        {column2Status ? (
          <div className='gridHLPure-status'>
            <span
              className={
                props.dataItem[field2Status]
                  ? 'gridHLPure-gridActive'
                  : 'gridHLPure-gridInactive'
              }
            >
              {props.dataItem[field2Status] === true ? t('gridHLPure.statusActive') : t('gridHLPure.statusInactive')}
            </span>
          </div>
        ) : (
          ''
        )}
      </td>
    )
  }

  const columnNoPasswordCell = (props) => {
    return (
      <td className={styleCol2}>
        <CheckBoxHLPure
          onChangeHandler={(e) => {
            if (onNoPasswordChange) {
              onNoPasswordChange(props.dataItem, e.target.checked)
            }
          }}
          checkedState={props.dataItem[fieldNoPassword] || false}
        />
      </td>
    )
  }

  const columnThreeCell = (props) => {
    let icon
    if (iconStatus) {
      icon = props.dataItem[iconStatus] ? iconOptionOne : iconOptionThree
    } else {
      icon = iconActiveThree ? iconOptionOne : iconOptionThree
    }

    return (
      <td className={styleCol3}>
        <div className={(labelsColumnsNoPadding) ? 'gridHLPure-containerAvatar-no-margin' : 'gridHLPure-containerAvatar'}>
          <div className='gridHLPure-imageAvatar'>
            {iconColumnThree ? (
              <img alt='profile-img' src={icon} className='gridHLPure-avatar' />
            ) : (
              <span>{props.dataItem[fieldRow3]}</span>
            )}
          </div>
        </div>
      </td>
    )
  }

  const columnFourthInboxCell = (props) => {
    return (
      <td className={styleCol5}>
        <span>{props.dataItem[fieldRow4]}</span>
      </td>
    )
  }

  const columnFifthInboxCell = (props) => {
    return (
      <td className={styleCol6}>
        <span>{props.dataItem[fieldRow5]}</span>
      </td>
    )
  }

  const gridColumnNoRecordsStyle = {
    color: '#2C353C',
    fontSize: '16px',
    fontWeight: 550,
    fontFamily: 'Quicksand',
  }

  const onPageChange = (event) => {
    setPage(event.page)
  }

  useEffect(() => {
    onSelectedItem(selectedItem)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItem])

  useEffect(() => {
    setPage(initialDataState)
  }, [dataGrid])

  const pagerSettings = {
    info: true,
    buttonCount: 5,
    type: 'numeric',
    previousNext: true,
  }

  return loading ? (
    <SimpleLoading />
  ) : (
    <Grid
      className={'gridHLPure'}
      data={dataGrid.slice(page.skip, page.take + page.skip)}
      reorderable
      style={gridSignatureRequestPanelStyle}
      skip={page.skip}
      take={page.take}
      pageable={pageable ? pagerSettings : null}
      total={dataGrid.length}
      onPageChange={onPageChange}
      filter={filter}
      onChangeFilter={onFilterChange}
    >
      <GridColumn
        field={fieldRow1}
        title={titleRow1}
        cell={inboxTypeCell ? SignRequestCellSolicilud : avatarCell}
        headerClassName={widthHeader}
        headerCell={solitudeInboxHeader1}
      />
      {column2Status ? (
        <GridColumn
          field={field2Status}
          title={title2Status}
          cell={columnTwoCell}
          headerCell={SignRequestCellHeader}
          headerClassName={widthHeaderCol2}
        />
      ) : (
        ''
      )}
      {columnThree ? (
        <GridColumn
          field={fieldRow3}
          title={titleRow3}
          iconStatus={iconStatus}
          cell={columnThreeCell}
          headerClassName={widthHeaderCol3}
          headerCell={solitudeInboxHeader}
        />
      ) : (
        ''
      )}
      {columnNoPassword ? (
        <GridColumn
          field={fieldNoPassword}
          title={titleNoPassword}
          cell={columnNoPasswordCell}
          headerCell={noPasswordHeaderCell}
          headerClassName={widthHeaderCol2}
        />
      ) : (
        ''
      )}
      {extraColumnInbox ? (
        <GridColumn
          field={fieldRow4}
          title={titleExtraColumn}
          cell={columnFourthInboxCell}
          headerCell={
            inboxTypeCell
              ? SignRequestCellHeaderInboxStart
              : SignRequestCellHeader
          }
        />
      ) : null}
      {otherExtraColumnInbox ? (
        <GridColumn
          field={fieldRow5}
          title={titleOtherExtraColumn}
          cell={columnFifthInboxCell}
          headerCell={
            inboxTypeCell
              ? SignRequestCellHeaderInboxLimit
              : SignRequestCellHeader
          }
        />
      ) : null}

      {featuresColumnInbox ? (
        <GridColumn
          field={otherFeaturesColumn}
          title={titleFeaturesColumn}
          cell={cellDetailAditionalServices()}
          headerCell={SignRequestCellHeader}
        />
      ) : null}
      {columnFour ? (
        <GridColumn
          title={titleRow4}
          cell={cellActions({
            setSelectedItem: setSelectedItem,
            props,
            setShowDetails: setShowDetails,
            setNameComponentUser: setNameComponentUser,
            iconOneActiveSelected,
            iconOneActive,
            iconTwoActive,
            iconTwoActiveSelected,
            iconThirdActive,
            iconFourthActive,
            iconFifthActive,
            iconTrashActive,
            labelOneActions,
            labelTwoActions,
            labelTwoActions2,
            labelThirdActions,
            labelFourthActions,
            labelFifthActions,
            labelTrashActions,
            styleCol4,
            activeDialog1,
            btnOpenDialog1,
            showDialogYesNo,
            activeDialog2,
            btnOpenDialog2,
            showDialogYesNo2,
            activeDialog5: props.activeDialog5,
            btnOpenDialog5: props.btnOpenDialog5,
            showDialogYesNo5: props.showDialogYesNo5,
            showIconFiveCondition: props.showIconFiveCondition,
            tooltipTrashIcon,
            activeDialogTrash,
            btnOpenDialogTrash,
            showDialogYesNoTrash,
            mobileFunction
          })}
          headerCell={SignRequestCellHeader}
          headerClassName={widthHeaderCol4}
        />
      ) : (
        ''
      )}
      {columnFourForInbox ? (
        <GridColumn
          title={titleRow4}
          cell={cellDetailSignatureRequest({
            selectedFilter: props.selectedFilter,
            buttonClasss: props.buttonClass,
            edit: props.edit,
            seeDetail: props.seeDetail,
            tracking: props.tracking,
            tooltipDetail: props.tooltipDetail,
            tooltipTracking: props.tooltipTracking,
            tooltipDelete: props.tooltipDelete,
            toggleDialogDeleteRequest: props.toggleDialogDeleteRequest,
            view: props.view,
            visibilityIcon: props.showTracking,
            userMiFirmaId: props.userMiFirmaId,
            killMe: props.killMe,
            isHideTrash: props.isHideTrash,
            styleCol4: styleCol4
          })}
          headerCell={SignRequestCellHeaderFourthCell}
          headerClassName={widthHeaderCol4}
        />
      ) : (
        ''
      )}
      <GridNoRecords>
        <span style={gridColumnNoRecordsStyle}>
          {t('configurationDomainPanel.notResults')}
        </span>
      </GridNoRecords>
    </Grid>
  )
}
export { GridHLPure as default }